import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

const FOOTER_OFFSET = 400;

@Component({
  selector: 'scroll-container',
  templateUrl: './scroll-container.component.html',
  styles: [
    '.loader-container { height: 50px; width: 50px; margin: 10px auto} ',
    '.loader-text {display: block; text-align: center; margin-bottom: 20px; font-size: 12px}',
  ],
  standalone: false,
})
export class ScrollContainerComponent {
  @Input() loading = false;
  @Input() reloading = false;
  @Input() initializing = false;
  @Input() loadingText = 'Loading more...';
  @Input() reloadingText = '';

  @Output() endOfContent = new EventEmitter<void>();

  private emittingEvent = false;

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.checkScroll();
  }

  // $event was being passed to a handler that declares no parameters and ignored it;
  // Angular 21 checks the arity, so the dead argument is dropped. Behaviour unchanged.
  @HostListener('touchend')
  @HostListener('touchcancel')
  onTouchMove(): void {
    this.checkScroll();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.checkScroll();
  }

  private checkScroll(): void {
    if (this.loading || this.initializing) {
      return;
    }

    if (this.emittingEvent) {
      return;
    }

    if (
      window.innerHeight + window.scrollY >=
      document.body.scrollHeight - FOOTER_OFFSET
    ) {
      this.emittingEvent = true;
      this.endOfContent.emit();
      // need some timout to avoid sending multiple events
      setTimeout(() => {
        this.emittingEvent = false;
      }, 1000);
    }
  }
}
